import { render, staticRenderFns } from "./TaxReturnWarrantySection.vue?vue&type=template&id=2b9c3ab5&scoped=true&"
import script from "./TaxReturnWarrantySection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnWarrantySection.vue?vue&type=script&lang=js&"
import style0 from "./TaxReturnWarrantySection.vue?vue&type=style&index=0&id=2b9c3ab5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9c3ab5",
  null
  
)

export default component.exports